<script>
export default {
    name: "TreatmentTab",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "prescription-tab": () => import('./tabs/Prescription.vue'),
        "none-drug-treatment-tab": () => import('./tabs/NoneDrugTreatment.vue'),
        "procedure-tab": () => import('./tabs/Procedure.vue'),
        "consultation-request-tab": () => import('./tabs/ConsultationRequest.vue'),
        "consumable-request-tab": () => import('./tabs/Consumables.vue'),
    },
}
</script>
<template>
<div class="w-full mt-2 p-tiny overflow-auto" style="height:55vh;">
    <ul class="flex border-b-2 border-gray-500">
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=0" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap" 
            :class="active == 0 ? activeClass : inActiveClass">Prescription</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=1"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold
                 whitespace-no-wrap"
            :class="active == 1 ? activeClass : inActiveClass">None Drug Treatment</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=2"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap"
            :class="active == 2 ? activeClass : inActiveClass">Procedures</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=3"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap"
            :class="active == 3 ? activeClass : inActiveClass">Consultation Request</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=4"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold 
                whitespace-no-wrap"
            :class="active == 4 ? activeClass : inActiveClass">Consumable Request</a>
      </li>
    </ul>
    <div class="w-full" v-if="active==0">
        <prescription-tab />
    </div>
    <div class="w-full" v-if="active==1">
        <none-drug-treatment-tab />
    </div>
    <div class="w-full" v-if="active==2">
        <procedure-tab></procedure-tab>
    </div>
    <div class="w-full" v-if="active==3">
        <consultation-request-tab />
    </div>
    <div class="w-full" v-if="active==4">
        <consumable-request-tab />
    </div>
</div>
</template>